// VoK MUI base styles
import borders from "app/assets/theme/base/borders";
import colors from "app/assets/theme/base/colors";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {borderWidth} = borders;
const {light} = colors;

const tableCell = {
    styleOverrides: {
        root: {
            padding: `${pxToRem(12)} ${pxToRem(16)}`,
            borderBottom: `${borderWidth[1]} solid ${light.main}`,
        },
    },
};

export default tableCell;
